import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import { handleApiErrors } from '../../lib/api-errors';
import {
  ALL_ORD_REQUESTING,
  ALL_STOCK_REQUESTING,
  BOND_LIST_REQUESTING,
  BRANCH_CODE_REQUESTING,
  CW_LIST_REQUESTING,
  DM_NGANH_REQUESTING,
  GET_STOCK_BY_ID_REQUESTING,
  INDEX_REQUESTING,
  LIST_30_REQUESTING,
  LIST_ETF_REQUESTING,
  LIST_MESSAGE_REQUESTING,
  LOLE_HSX_SNAPSHOT_REQUESTING,
  LOLE_SNAPSHOT_REQUESTING,
  MARGIN_LIST_REQUESTING,
  NDATA_SNAPSHOT_REQUESTING,
  NOI_CAP_REQUESTING,
  PS_INDEX_REQUESTING,
  PS_LIST_REQUESTING,
  PS_SNAPSHOT_REQUESTING,
  PT_LIST_REQUESTING,
  SNAPSHOT_PART_REQUESTING,
  SNAPSHOT_REQUESTING,
  SNAPSHOT_UNDERLYING_REQUESTING,
  STOCK_INFO_REQUESTING,
  SUMMARY_REQUESTING,
  TOP_INTEREST_REQUESTING,
  TOP_VOLUME_REQUESTING,
  TRADE_HIS_PS_REQUESTING,
  WORLD_INDEX_REQUESTING,
} from './constants';

import { getConfig, getMessage } from '../../lib/selector';
import {
  _processMapDataCS,
  _processMapDataIndex,
  _processMapDataPS,
} from '../../utils';
import {
  allOrdRequestError,
  allOrdRequestSuccess,
  allStockRequestError,
  allStockRequestSuccess,
  bondListRequestError,
  bondListRequestSuccess,
  branchCodeRequestError,
  branchCodeRequestSuccess,
  cwListRequestError,
  cwListRequestSuccess,
  dmNganhRequestError,
  dmNganhRequestSuccess,
  getStockByIdRequestError,
  getStockByIdRequestSuccess,
  indexRequestError,
  indexRequestSuccess,
  indSumRequestError,
  indSumRequestSuccess,
  list30RequestError,
  list30RequestSuccess,
  listEtfRequestError,
  listEtfRequestSuccess,
  listMessageRequestError,
  listMessageRequestSuccess,
  loleHSXSnapshotRequestError,
  loleHSXSnapshotRequestSuccess,
  loleSnapshotRequestError,
  loleSnapshotRequestSuccess,
  marginListRequestError,
  marginListRequestSuccess,
  ndataSnapshotRequestError,
  ndataSnapshotRequestSuccess,
  noicapRequestError,
  noicapRequestSuccess,
  psIndexRequestError,
  psIndexRequestSuccess,
  psListRequestError,
  psListRequestSuccess,
  psSnapshotRequestError,
  psSnapshotRequestSuccess,
  ptListRequestError,
  ptListRequestSuccess,
  snapshotPartRequestError,
  snapshotPartRequestSuccess,
  snapshotRequestError,
  snapshotRequestSuccess,
  snapshotUnderlyingCWError,
  snapshotUnderlyingCWSuccess,
  stockInfoRequestError,
  stockInfoRequestSuccess,
  topInterestRequestError,
  topInterestRequestSuccess,
  topVolumeError,
  topVolumeSuccess,
  tradeHisPsRequestError,
  tradeHisPsRequestSuccess,
  worldIndexRequestError,
  worldIndexRequestSuccess,
} from './actions';

import { sortBy } from 'lodash';

const appUrl = `${process.env.REACT_APP_API_URL}`;
const infoUrl = `${process.env.REACT_APP_INFO_URL}`;
let priceUrl; // = `${process.env.REACT_APP_PRICE_URL}`;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => {
      throw error;
    });
}

function handleRequestText(request) {
  return request
    .then(handleApiErrors)
    .then((response) => response.text())
    .then((json) => json)
    .catch((error) => {
      throw error;
    });
}

function allStockRequestApi() {
  const url = `${priceUrl}/getlistallstock`;
  const request = fetch(url);

  return handleRequest(request);
}

function marginListRequestApi() {
  const url = `${priceUrl}/getMarginList`;
  const request = fetch(url);

  return handleRequest(request);
}

function ptListRequestApi() {
  const url = `${priceUrl}/getPTList`;
  const request = fetch(url);

  return handleRequest(request);
}

function psListRequestApi() {
  const url = `${priceUrl}/pslistdata`;
  const request = fetch(url);

  return handleRequest(request);
}

function cwListRequestApi() {
  const url = `${infoUrl}/listCW.pt`;
  const request = fetch(url);

  return handleRequest(request);
}

function bondListRequestApi() {
  const url = `${infoUrl}/listBond.pt`;
  const request = fetch(url);

  return handleRequest(request);
}

function list30RequestApi(data) {
  const url = `${infoUrl}/adv_getliststockbyid/${
    data === 'HSX30' ? 'VN30' : data
  }`;
  const request = fetch(url);

  return handleRequestText(request);
}

function listEtfRequestApi(data) {
  const url = `${infoUrl}/listETF.pt?market=${data}`;
  const request = fetch(url);

  return handleRequest(request);
}

function listMessageRequestApi() {
  return null;
  const url = `${appUrl}/listMessage`;
  const request = fetch(url);

  return handleRequest(request);
}

function branchCodeRequestApi() {
  const url = `${appUrl}/getInmemList/BRANCH_CODE`;
  const request = fetch(url);

  return handleRequest(request);
}

function noicapRequestApi() {
  const url = `${appUrl}/getInmemList/NOI_CAP`;
  const request = fetch(url);

  return handleRequest(request);
}

function indSumRequestApi() {
  const url = `${priceUrl}/getSummary`;
  const request = fetch(url);

  return handleRequest(request);
}

function snapshotRequestApi(data) {
  const url = `${priceUrl}/getliststockdata/${data.toUpperCase()}`;
  const request = fetch(url);

  return handleRequest(request);
}

function loleSnapshotRequestApi(data) {
  const url = `${priceUrl}/getliststockdataoddlot/${data.toUpperCase()}`;
  const request = fetch(url);

  return handleRequest(request);
}

function loleHSXSnapshotRequestApi() {
  const url = `${priceUrl}/getOddLotData/HSX`;
  const request = fetch(url);

  return handleRequest(request);
}

function psSnapshotRequestApi(data) {
  const url = `${priceUrl}/getpsalldatalsnapshot/${data.toUpperCase()}`;
  const request = fetch(url);

  return handleRequest(request);
}

function stockByIdRequestApi(data) {
  const url = `${appUrl}/getliststockById/${data}`;
  const request = fetch(url);

  return handleRequest(request);
}

function worldIndexRequestApi() {
  const url = `${priceUrl}/getlistbaseworldindex/`;
  const request = fetch(url);

  return handleRequest(request);
}

function indexRequestApi(data) {
  const url = `${priceUrl}/getlistindexdetail/${data}`;
  const request = fetch(url);

  return handleRequest(request);
}

function ndataRequestApi(data) {
  const url = `https://banggia.tvs.vn/getps10pricesnapshot/${data}`;
  const request = fetch(url);

  return handleRequest(request);
}

function tradeHisPsRequestApi(data) {
  const url = `https://bddatafeed.vps.com.vn/getpschartintraday/${data}`;
  const request = fetch(url);

  return handleRequest(request);
}

function dmNganhRequestApi(data) {
  const url = `https://banggia.tvs.vn:8083/webservices.vnd?msgType=loadCategories`;
  const request = fetch(url);

  return handleRequest(request);
}

function topInterestRequestApi() {
  const url = `${infoUrl}/getTopByVolume/10,pcu`;
  const request = fetch(url);

  return handleRequest(request);
}

function topVolumeRequestApi() {
  const url = `${infoUrl}/getTopByVolume/10,i`;
  const request = fetch(url);

  return handleRequest(request);
}

function allOrderRequestApi(data) {
  const url = `${appUrl}/CoreServlet.pt`;
  const request = fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function* allStockRequestFlow() {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    const dataList = yield call(allStockRequestApi);

    yield put(allStockRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(allStockRequestError(error));
  }
}

function* marginListRequestFlow() {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    const dataList = yield call(marginListRequestApi);

    yield put(marginListRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(marginListRequestError(error));
  }
}

function* snapshotRequestFlow({ data }) {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    console.log(config);
    const dataList = yield call(snapshotRequestApi, data);
    console.log('snapshotRequestFlow');
    let csData = [];
    dataList.forEach((item) => {
      let symbol = _processMapDataCS(item);
      csData.push(symbol);
    });

    yield put(snapshotRequestSuccess(csData));
  } catch (error) {
    yield put(snapshotRequestError(error));
  }
}

function* snapshotUnderlyingRequestFlow(action) {
  try {
    const { data } = action;
    const dataList = yield call(snapshotRequestApi, data);
    console.log('snapshotUnderlyingRequestFlow');
    let csData = [];
    dataList.forEach((item) => {
      let symbol = _processMapDataCS(item);
      csData.push(symbol);
    });

    yield put(snapshotUnderlyingCWSuccess(csData));
  } catch (error) {
    yield put(snapshotUnderlyingCWError(error));
  }
}

function* psSnapshotRequestFlow({ data }) {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    const dataList = yield call(psSnapshotRequestApi, data);
    console.log('psSnapshotRequestFlow');
    let psData = [];
    dataList.forEach((item) => {
      let symbol = _processMapDataPS(item);
      psData.push(symbol);
    });

    yield put(psSnapshotRequestSuccess(psData));
  } catch (error) {
    yield put(psSnapshotRequestError(error));
  }
}

function* psIndexRequestFlow(action) {
  try {
    const { data } = action;
    const dataList = yield call(psSnapshotRequestApi, data);
    console.log('psIndexRequestFlow');
    let psData = [];
    dataList.forEach((item) => {
      let symbol = _processMapDataPS(item);
      psData.push(symbol);
    });

    yield put(psIndexRequestSuccess(psData));
  } catch (error) {
    yield put(psIndexRequestError(error));
  }
}

function* snapshotPartRequestFlow(action) {
  try {
    const { data } = action;
    // console.log(data)
    const dataList = yield call(snapshotRequestApi, data);
    console.log('snapshotPartRequestFlow');
    let csData = [];
    dataList.forEach((item) => {
      let symbol = _processMapDataCS(item);
      csData.push(symbol);
    });

    yield put(snapshotPartRequestSuccess(csData));
  } catch (error) {
    yield put(snapshotPartRequestError(error));
  }
}

function* loleSnapshotRequestFlow({ data }) {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    // console.log(data)
    const dataList = yield call(loleSnapshotRequestApi, data);
    console.log('loleSnapshotRequestFlow');

    yield put(loleSnapshotRequestSuccess(dataList));
  } catch (error) {
    yield put(loleSnapshotRequestError(error));
  }
}

function* loleHSXSnapshotRequestFlow() {
  try {
    const dataList = yield call(loleHSXSnapshotRequestApi);
    console.log('loleSnapshotRequestFlow HSX');

    let arrData = [];
    dataList.forEach((element) => {
      arrData.push(element.data);
    });

    console.log(arrData);

    yield put(loleHSXSnapshotRequestSuccess(sortBy(arrData, 'sym')));
  } catch (error) {
    console.log(error);
    yield put(loleHSXSnapshotRequestError(error));
  }
}

function* stockInfoRequestFlow(action) {
  try {
    console.log('stockInfoRequestFlow', action);
    const { data } = action;
    const dataList = yield call(snapshotRequestApi, data);

    let csData = [];
    dataList.forEach((item) => {
      let symbol = _processMapDataCS(item);
      csData.push(symbol);
    });

    yield put(stockInfoRequestSuccess(csData));
  } catch (error) {
    console.log(error);
    yield put(stockInfoRequestError(error));
  }
}

function* allOrderRequestFlow(action) {
  try {
    const { data } = action;
    const resData = yield call(allOrderRequestApi, data);
    if (resData.http !== 200) {
      if (resData.http === 401) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('authen');

        yield put({ type: 'INVALID_SESSION', resData: resData.data.message });
      }
      const msgErr = yield select(getMessage, resData);
      throw Error(msgErr);
    }

    yield put(allOrdRequestSuccess(resData.data));
  } catch (error) {
    // console.log(error)
    yield put(allOrdRequestError(error));
  }
}

function* ptListRequestFlow() {
  try {
    const dataList = yield call(ptListRequestApi);

    yield put(ptListRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(ptListRequestError(error));
  }
}

function* psListRequestFlow() {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    const dataList = yield call(psListRequestApi);

    yield put(psListRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(psListRequestError(error));
  }
}

function* cwListRequestFlow() {
  try {
    const dataList = yield call(cwListRequestApi);

    yield put(cwListRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(cwListRequestError(error));
  }
}

function* bondSnapshotRequestFlow() {
  try {
    const dataList = yield call(bondListRequestApi);

    yield put(bondListRequestSuccess(dataList?.data));
  } catch (error) {
    // console.log(error)
    yield put(bondListRequestError(error));
  }
}

function* list30RequestFlow({ data }) {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    const dataList = yield call(list30RequestApi, data);

    yield put(
      list30RequestSuccess({
        list: dataList,
      })
    );
  } catch (error) {
    // console.log(error)
    yield put(list30RequestError(error));
  }
}

function* listEtfRequestFlow({ data }) {
  try {
    const dataList = yield call(listEtfRequestApi, data);

    yield put(listEtfRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(listEtfRequestError(error));
  }
}

function* listMessageRequestFlow() {
  try {
    const dataList = yield call(listMessageRequestApi);

    yield put(listMessageRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(listMessageRequestError(error));
  }
}

function* branchCodeRequestFlow() {
  try {
    const dataList = yield call(branchCodeRequestApi);

    yield put(branchCodeRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(branchCodeRequestError(error));
  }
}

function* noicapRequestFlow() {
  try {
    const dataList = yield call(noicapRequestApi);

    yield put(noicapRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(noicapRequestError(error));
  }
}

function* indSumRequestFlow() {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    const dataList = yield call(indSumRequestApi);

    yield put(indSumRequestSuccess(dataList));
  } catch (error) {
    // console.log(error)
    yield put(indSumRequestError(error));
  }
}

function* stockByIdRequestFlow(action) {
  try {
    const { data } = action;
    const dataList = yield call(stockByIdRequestApi, data);

    let csData = [];
    dataList.forEach((item) => {
      let symbol = _processMapDataCS(item);
      csData.push(symbol);
    });

    yield put(getStockByIdRequestSuccess(csData));
  } catch (error) {
    yield put(getStockByIdRequestError(error));
  }
}

function* worldIndexRequestFlow() {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    const worldList = yield call(worldIndexRequestApi);
    console.log('worldList');
    yield put(worldIndexRequestSuccess(worldList));
  } catch (error) {
    yield put(worldIndexRequestError(error));
  }
}

function* indexRequestFlow({ data }) {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }

    const indexs = yield call(indexRequestApi, data);
    let indexList = [];
    indexs &&
      !!indexs.length &&
      indexs.forEach((element) => {
        indexList.push(_processMapDataIndex(element));
      });
    console.log('indexRequestFlow');
    yield put(indexRequestSuccess(indexList));
  } catch (error) {
    yield put(indexRequestError(error));
  }
}

function* ndataSnapshotRequestFlow(action) {
  try {
    // grab the data from our action
    const { data } = action;

    const ndata = yield call(ndataRequestApi, data);
    yield put(ndataSnapshotRequestSuccess(ndata));
  } catch (error) {
    yield put(ndataSnapshotRequestError(error));
  }
}

function* tradeHisPsRequestFlow(action) {
  try {
    // grab the data from our action
    const { data } = action;

    const ndata = yield call(tradeHisPsRequestApi, data);
    yield put(tradeHisPsRequestSuccess(ndata));
  } catch (error) {
    yield put(tradeHisPsRequestError(error));
  }
}

function* dmNganhRequestFlow() {
  try {
    const dataList = yield call(dmNganhRequestApi);
    console.log(dataList);
    yield put(dmNganhRequestSuccess(dataList));
  } catch (error) {
    yield put(dmNganhRequestError(error));
  }
}

function* topInterestRequestFlow() {
  try {
    const dataList = yield call(topInterestRequestApi);
    console.log(dataList);
    yield put(topInterestRequestSuccess(dataList));
  } catch (error) {
    yield put(topInterestRequestError(error));
  }
}

function* topVolumeRequestFlow() {
  try {
    const dataList = yield call(topVolumeRequestApi);
    console.log(dataList);
    yield put(topVolumeSuccess(dataList));
  } catch (error) {
    yield put(topVolumeError(error));
  }
}

function* priceboardWatcher() {
  yield all([
    takeLatest(ALL_STOCK_REQUESTING, allStockRequestFlow),
    takeLatest(SNAPSHOT_REQUESTING, snapshotRequestFlow),
    takeLatest(SNAPSHOT_UNDERLYING_REQUESTING, snapshotUnderlyingRequestFlow),
    takeEvery(SNAPSHOT_PART_REQUESTING, snapshotPartRequestFlow),
    takeLatest(STOCK_INFO_REQUESTING, stockInfoRequestFlow),
    takeLatest(ALL_ORD_REQUESTING, allOrderRequestFlow),
    takeLatest(PT_LIST_REQUESTING, ptListRequestFlow),
    takeLatest(PS_LIST_REQUESTING, psListRequestFlow),
    takeLatest(PS_SNAPSHOT_REQUESTING, psSnapshotRequestFlow),
    takeLatest(PS_INDEX_REQUESTING, psIndexRequestFlow),
    takeLatest(BOND_LIST_REQUESTING, bondSnapshotRequestFlow),
    takeLatest(CW_LIST_REQUESTING, cwListRequestFlow),
    takeLatest(LIST_30_REQUESTING, list30RequestFlow),
    takeLatest(LIST_ETF_REQUESTING, listEtfRequestFlow),
    takeLatest(LIST_MESSAGE_REQUESTING, listMessageRequestFlow),
    takeLatest(BRANCH_CODE_REQUESTING, branchCodeRequestFlow),
    takeLatest(NOI_CAP_REQUESTING, noicapRequestFlow),
    takeLatest(SUMMARY_REQUESTING, indSumRequestFlow),
    takeLatest(GET_STOCK_BY_ID_REQUESTING, stockByIdRequestFlow),
    takeLatest(WORLD_INDEX_REQUESTING, worldIndexRequestFlow),
    takeLatest(INDEX_REQUESTING, indexRequestFlow),
    takeEvery(NDATA_SNAPSHOT_REQUESTING, ndataSnapshotRequestFlow),
    takeLatest(TRADE_HIS_PS_REQUESTING, tradeHisPsRequestFlow),
    takeLatest(DM_NGANH_REQUESTING, dmNganhRequestFlow),
    takeLatest(LOLE_SNAPSHOT_REQUESTING, loleSnapshotRequestFlow),
    takeLatest(LOLE_HSX_SNAPSHOT_REQUESTING, loleHSXSnapshotRequestFlow),
    takeLatest(MARGIN_LIST_REQUESTING, marginListRequestFlow),

    takeLatest(TOP_INTEREST_REQUESTING, topInterestRequestFlow),
    takeLatest(TOP_VOLUME_REQUESTING, topVolumeRequestFlow),
  ]);
}

export default priceboardWatcher;
